import { Image } from "./image";
import React, {useState} from "react";
import { useTranslation} from 'react-i18next';
import { GalleryModal } from "./gallery_modal";
import Badge from 'react-bootstrap/Badge';
import MaterialIcon from "react-google-material-icons";

export const Gallery = (props) => {
  const { t } = useTranslation();
  const impression = [];
  const [showDetails, setShowDetails] = useState(false);
  const [selectedSrc, setSelectedSrc] = useState("");
  const [selectedText, setSelectedText] = useState([]);
  const [selectedHeading, setSelectedHeading] = useState("");
  const [selectedImgSize, setSelectedImgSize] = useState({});

  for (var i=0; i < t("Orchestra.count"); i++) {
    
    let bullets = [];
    for (var j=0; j<t("Orchestra.impression_"+i+".textSize"); j++ ) {
      bullets.push(t("Orchestra.impression_"+i+".text."+j));
    }
    
    impression.push({
      "title": t("Orchestra.impression_"+i+".title"),
      "img": t("Orchestra.impression_"+i+".img"),
      "text": bullets,
      "width": t("Orchestra.impression_"+i+".width"),
      "height": t("Orchestra.impression_"+i+".height"),
    });
  } 

  const handleSelectDetails = (e, src, heading, text, width, height) => {
    setShowDetails(true);
    setSelectedSrc(src);
    setSelectedText(text);
    setSelectedHeading(heading);
    setSelectedImgSize({w: width, h: height});
  }

  const closeDetailsView = () => {
    setShowDetails(false);
    setSelectedSrc("");
    setSelectedText([]);
    setSelectedHeading(""); 
    setSelectedImgSize({});   
  }

  return (
    <>
    {
      showDetails ? <GalleryModal 
                      img={selectedSrc} 
                      heading={selectedHeading} 
                      text={selectedText} 
                      size={selectedImgSize} 
                      callback={closeDetailsView} 
                    /> 
                    : 
                    null
    }
    <div id="portfolio" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>
            {t("Orchestra.title")}
            <img src="img/OrchestraLogoApplication.png" height="150px" alt="Not found" />
          </h2>
          <p>
          {t("Orchestra.pitch")}
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items">         
            {impression.length > 0
              ? impression.map((d, i) => (
                  <div
                    key={`${d.title}-${i}`}
                    className="col-sm-6 col-md-4 col-lg-4"
                    onClick={(e) => handleSelectDetails(e, d.img, d.title, d.text, d.width, d.height)}
                  >
                    <Image
                      title={d.title}
                      image={d.img}
                    /> 
                    <MaterialIcon icon="ads_click" className="click-hint" size={30}/>
                    { i===6 ?
                      <Badge 
                        className="badge-overlay2"
                      >
                        Coming Soon
                      </Badge>                      
                      : null
                    }                                       
                  </div>
                ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};
